/* Le Bain d'Air — barre d'achat collante mobile (autonome, défensive) */
(function () {
  'use strict';

  var CSS =
    '.lba-sticky-cart{position:fixed;left:0;right:0;bottom:0;z-index:40;display:flex;' +
    'align-items:center;gap:12px;padding:10px 14px calc(10px + env(safe-area-inset-bottom,0px));' +
    'background:rgba(255,255,255,.97);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);' +
    'box-shadow:0 -6px 24px rgba(27,47,110,.14);transform:translateY(130%);transition:transform .28s ease}' +
    '.lba-sticky-cart.is-visible{transform:translateY(0)}' +
    '.lba-sticky-cart__img{width:46px;height:46px;border-radius:8px;object-fit:cover;flex:none;background:#f2f6f9}' +
    '.lba-sticky-cart__info{flex:1 1 auto;min-width:0}' +
    '.lba-sticky-cart__title{font-size:.8rem;color:#1b2f6e;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.lba-sticky-cart__price{font-size:.9rem;color:#33465c}' +
    '.lba-sticky-cart__btn{flex:none;background:#1b2f6e;color:#fff;border:none;border-radius:14px;' +
    'padding:12px 20px;font-weight:600;font-size:.9rem;cursor:pointer;white-space:nowrap}' +
    '.lba-sticky-cart__btn:active{background:#3aafc9}' +
    '@media(min-width:750px){.lba-sticky-cart{display:none!important}}';

  function injectCSS() {
    if (document.getElementById('lba-sticky-cart-css')) return;
    var s = document.createElement('style');
    s.id = 'lba-sticky-cart-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function init() {
    try {
      if (document.querySelector('.lba-sticky-cart')) return; // évite le doublon

      var main = document.getElementById('MainContent');
      var tmpl = main && main.getAttribute('data-template');
      if (!tmpl || tmpl.indexOf('product') !== 0) return; // pages produit uniquement

      var realBtn = document.querySelector('product-form-component [ref="addToCartButton"]')
                 || document.querySelector('.buy-buttons-block button[type="submit"]');
      if (!realBtn) return;

      var buyBlock = realBtn.closest('.buy-buttons-block') || realBtn;

      var titleEl = document.querySelector('.product-details h1') || document.querySelector('#MainContent h1');
      var title = titleEl ? titleEl.textContent.trim() : (document.title || '');

      var priceEl = document.querySelector('.product-details .price')
                 || document.querySelector('.product-information .price');

      var imgEl = document.querySelector('.product-information img')
               || document.querySelector('#MainContent img');
      var imgSrc = imgEl ? (imgEl.currentSrc || imgEl.src) : '';

      injectCSS();

      var bar = document.createElement('div');
      bar.className = 'lba-sticky-cart';
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'Ajouter au panier');
      bar.innerHTML =
        '<img class="lba-sticky-cart__img" alt="" ' + (imgSrc ? 'src="' + imgSrc + '"' : '') + '>' +
        '<div class="lba-sticky-cart__info">' +
          '<div class="lba-sticky-cart__title"></div>' +
          '<div class="lba-sticky-cart__price"></div>' +
        '</div>' +
        '<button type="button" class="lba-sticky-cart__btn">Ajouter au panier</button>';

      bar.querySelector('.lba-sticky-cart__title').textContent = title;
      var priceOut = bar.querySelector('.lba-sticky-cart__price');
      if (priceEl) priceOut.textContent = priceEl.textContent.trim();

      document.body.appendChild(bar);

      bar.querySelector('.lba-sticky-cart__btn').addEventListener('click', function () {
        try { realBtn.click(); } catch (e) {}
      });

      if (priceEl && window.MutationObserver) {
        var mo = new MutationObserver(function () {
          priceOut.textContent = priceEl.textContent.trim();
        });
        mo.observe(priceEl, { childList: true, subtree: true, characterData: true });
      }

      var ticking = false;
      var raf = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };
      function update() {
        ticking = false;
        var rect = buyBlock.getBoundingClientRect();
        // Afficher la barre dès que le bloc d'achat est entièrement remonté au-dessus de l'écran
        if (rect.bottom < 0) {
          bar.classList.add('is-visible');
        } else {
          bar.classList.remove('is-visible');
        }
      }
      function onScroll() {
        if (!ticking) { ticking = true; raf(update); }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    } catch (err) {
      /* échec silencieux : ne jamais casser la page */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
